const TRAINING_DEEP_LINKS_ROUTES = {
  PLAN_BY_ID: 'plans?id=:id',
  WORKOUT_BY_ID: 'workouts?id=:id',
  WORKOUT_BY_SHARE_KEY: 'workouts?shareKey=:shareKey'
}

export {
  TRAINING_DEEP_LINKS_ROUTES
}
